import React from 'react'
import { Text } from 'react-native'
import useDateFormat from '@ui/hooks/useDateFormat'

interface Props {
  date: Date | string | undefined
  options?: Intl.DateTimeFormatOptions
  locale?: string
}

export default function DateTime(props: Props) {
  const format = useDateFormat(props.options, props.locale)

  if (!props.date) return <Text>—</Text>

  const formattedDate = format(props.date)

  return <Text>{formattedDate}</Text>
}
